import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Menu,
  MenuItem,
  Modal as ShellModal,
} from '@sede-enterprise/shell-ds-react-framework';
import routepaths from '../../../router/routepaths';
import { put } from '../../../services/GenesisApi';
import { sendNotification } from '../../../UI/Notification';

const UserOptionsContainer = styled.div`
  z-index: 5;
  width: 100%;
  & > div {
    width: 100%;
  }
`;

const Options = styled(Menu)`
  width: 200px;
`;

const Modal = styled(ShellModal)`
  .shell-modal-container-content {
    min-height: 150px !important;
  }
  .shell-modal-container-body {
    width: 100%;
  }
`;

const UserOptions = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClick = () => {
    setIsOpen(true);
    put('/api/User/Signout', {})
      .then(() => {
        navigate(routepaths.logout);
      })
      .catch((error) => {
        sendNotification({
          type: 'error',
          message: error.message,
        });
      })
      .finally(() => {
        setIsOpen(false);
      });
  };

  return (
    <UserOptionsContainer>
      <Options size='large'>
        <MenuItem onClick={onClick}>Logout</MenuItem>
      </Options>
      <Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        loading
        loadingBody={<>Logging off...</>}
        closable={false}
        maskClosable={false}
        width={200}
        centered
      />
    </UserOptionsContainer>
  );
};

export default UserOptions;
